// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1__f8cc535f06af6ba4f598","cls2":"AutoCompleteResultRow-cls2___160d21a0346119a1f2c AutoCompleteResultRow-cls1__f8cc535f06af6ba4f598"};